import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PlayButton from './ui/PlayButton';
import LoadingBar from './ui/LoadingBar';
import ListFilter from './filters/ListFilter';
import PaginationButtons from './PaginationButtons';

import config from './../config';
import helpers from './../lib/helpers';

class LocationThingList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: null,
			nextUrl: null,
			previousUrl: null,
			resultCount: 0,
			loading: true,
			lastParams: '',
			initialized: false
		};
	}

	componentDidMount() {
		if (this.props.locationId || this.props.searchParams) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.locationId != prevProps.locationId || this.props.searchParams != prevProps.searchParams) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			loading: true,
			data: null
		});

		let urlParams = [];

		if (this.props.locationId) {
			urlParams.push('location='+this.props.locationId)
		}

		helpers.fetch(config.apiRoot+'/api/locations/things/?'+urlParams.join('&'), (json) => {
			this.setState({
				data: json.results,
				loading: false,
				nextUrl: json.next,
				previousUrl: json.previous,
				resultCount: json.count
			});

			if (this.props.onResponse) {
				this.props.onResponse(json.results);
			}
		});
	}

	render() {
		return <div className={'position-relative '+(this.props.className || '')+(this.state.loading ? ' loading' : '')}>
			<LoadingBar />
			{
				this.state.data && this.state.data.length > 0 &&
				<React.Fragment>
					{
						this.props.children
					}
					<table className="table">
						<thead>
							<tr>
								<th width="80%">Nafn</th>
								<th width="20%"></th>
							</tr>
						</thead>
						<tbody>
							{
								this.state.data.map((item, index) => <tr key={index}>
									<td>
										<Link to={helpers.routerUrls['orgel']+item.thing.id}>
											{
												item.thing.name
											}
										</Link>
										{
											item.thing.brand &&
											<React.Fragment>
												<br/>{item.thing.brand}
											</React.Fragment>
										}
									</td>
									<th>{
										(item.date_from || item.date_to) &&
										<React.Fragment>{helpers.formatDate(item.date_from, true)+'–'+helpers.formatDate(item.date_to, true)}</React.Fragment>
									}</th>
								</tr>)
							}
						</tbody>
					</table>
				</React.Fragment>
			}
		</div>
	}
}

export default LocationThingList;
